
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Nein, weniger Schlaf als junge Menschen brauchen alte nicht. Laut der US-amerikanischen `}<Link href='https://www.sleephealthjournal.org/article/S2352-7218%2815%2900015-7/fulltext' mdxType="Link">{`National Health Foundation`}</Link>{` schlafen Babys pro Nacht zwischen 14 und 17 Stunden, Erwachsene zwischen sieben und neun Stunden und über 65-Jährige zwischen sieben und acht Stunden. Wenn Menschen älter werden, wandelt sich ihr Schlafmuster in vielfältiger Weise. `}<M mdxType="M">{`Erstaunlich konstant aber bleibt dabei das Schlafbedürfnis.`}</M>{` Klar ist: Während die REM-Phasen (Traumschlaf) etwa gleich lang bleiben, werden die Tiefschlafphasen bei Senioren tendenziell kürzer und die Leichtschlafphasen länger. Dies führt dazu, dass nur noch wenige alte Menschen acht Stunden am Stück schlafen können und in der Nacht öfter aufwachen. `}<br /><br />{`
Der Begriff «senile Bettflucht» kommt übrigens auch nicht von ungefähr. Hier geht es aber weniger um die Schlafdauer, sondern um den Zeitpunkt des Zu-Bett-Gehens. Da die meisten älteren und alten Menschen früher Schlafen gehen als junge Leute, stehen sie häufig auch früher auf. Dazu kommen noch Probleme wie erhöhter Harndrang. Der Nachtschlaf verkürzt sich also – dafür haben die meisten Senioren aber tagsüber Zeit, ein Nickerchen zu machen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;